
























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Feature } from '../../../common/types';

@Component({
  components: {},
})
export default class RightImageFeature extends Vue {
  // Data
  @Prop() feature!: Feature;
  // Methods
}
